import {automaticApi} from "../../../../settings/api";
import { AxiosResponse } from "axios";
import { Action } from "redux-saga";
import { call, CallEffect, put, PutEffect } from "redux-saga/effects";
import environment from "@/settings/environment";
import { setCustomer } from "@/redux/ducks/customer";
import { ReducersTypes } from "@/redux/reducers/Models";
import { mergeVehicleLists } from "@/redux/sagas/vehicles/utils";

declare global {
    interface Window { dataLayer: any[]; }
}

export interface Fetch {
    callback: (success: boolean) => void;
}

export interface GetDataAction {
    type: string;
    payload: Fetch;
}

const getCustomer = (state: ReducersTypes) => state.customerReducer;

export default function* getData({
    payload,
}: GetDataAction): Generator<
    CallEffect<unknown> | PutEffect<Action>,
    void,
    AxiosResponse
> {
    try {
        const response = yield call(automaticApi.get, `/login-app/${environment.api?.loginVersion ?? "v4"}/userdata`);
        const respondeData = response?.data;

        if (respondeData?.status?.sessionId) {
            window?.dataLayer?.push({
                userId: response?.data?.client?.id
            });
            yield put(
                setCustomer({
                    client: response?.data?.client,
                    account: response?.data?.account,
                    isLoadingVehicles: false,
                })
            );
            const responseProducts = yield call(
                automaticApi.get,
                '/home-app/v1/init/userproduct'
            );

            // Combina veículos do CBILL (`listVehicle`) com os do serviço de
            // garagem do app (`listGarageVehicle`) em uma única lista.
            const vehicles = mergeVehicleLists(
                responseProducts?.data?.listVehicle,
                responseProducts?.data?.listGarageVehicle,
            );

            // Inicializa selectedVehicles com todos os veículos retornados
            const selectedVehicles = vehicles?.map((vehicle) => vehicle.plate);
            const shouldInitializeSelectedVehicles = (selectedVehicles?.length ?? 0) > 0;

            yield put(
                setCustomer({
                    products: responseProducts?.data?.products,
                    vehicles: vehicles,
                    ...(shouldInitializeSelectedVehicles && selectedVehicles && { selectedVehicles })
                })
            );
            yield call(payload.callback, true);
        } else {
            yield put(
                setCustomer({
                    isLoadingVehicles: false,
                })
            );
            yield call(payload.callback, false);
        }

    } catch (error) {
        yield put(
            setCustomer({
                isLoadingVehicles: false,
            })
        );
        yield call(payload.callback, false);
    }
}